import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/shell/session'
import { Building } from 'lucide-react'
import { TenantScreen } from '@/screens/platform/SCR-060-tenant'

// SCR-060 Tenant operations (platform area, super admins only).
export const Route = createFileRoute('/_app/platform/tenants/$tenantId')({
  beforeLoad: requireSuperAdmin,
  staticData: { screen: { id: 'SCR-060', title: 'Tenant operations', group: 'Platform', hidden: true, platform: true, description: 'One organisation: plan, usage, health and support actions.', icon: Building } },
  component: TenantScreen,
})
